import React, { useState, createContext, useMemo } from 'react';
import logComponent from '../common/logComponent';

// create context
const CardLatestCheckInContext = createContext(null);

// declare provider component
const CardLatestCheckInProvider = ({ children }) => {

  const [latestCheckIn, setLatestCheckIn] = useState(null);
  const [latestCheckInLoading, setLatestCheckInLoading] = useState(null);
  const [latestCheckInError, setLatestCheckInError] = useState(null);
  



  const setTheLatestCheckIn = (latestCheckIn) => {
    if (logComponent('CardLatestCheckInContext')) { console.debug('CardLatestCheckInContext setTheLatestCheckIn'); }
    let newLatestCheckIn = latestCheckIn ? { ...latestCheckIn } : null;
    setLatestCheckIn(newLatestCheckIn);
  }

  const setTheLatestCheckInLoading = (latestCheckInLoading) => {
    if (logComponent('CardLatestCheckInContext')) { console.debug('CardLatestCheckInContext setTheLatestCheckInLoading'); }
    let newLatestCheckInLoading = latestCheckInLoading;
    setLatestCheckInLoading(newLatestCheckInLoading);
  }

  const setTheLatestCheckInError = (latestCheckInError) => {
    if (logComponent('CardLatestCheckInContext')) { console.debug('CardLatestCheckInContext setTheLatestCheckInError'); }
    let newLatestCheckInError = latestCheckInError;
    setLatestCheckInError(newLatestCheckInError);
  }


  const cardState = useMemo(() => ({
    latestCheckIn,
    latestCheckInLoading,
    latestCheckInError,
    setLatestCheckIn: setTheLatestCheckIn,
    setLatestCheckInLoading: setTheLatestCheckInLoading,
    setLatestCheckInError: setTheLatestCheckInError
  }), [
    latestCheckIn,
    latestCheckInLoading,
    latestCheckInError
]);

  return (
    <CardLatestCheckInContext.Provider value={ cardState }>
      {children}
    </CardLatestCheckInContext.Provider>
  );
}

// export provider and context
export { CardLatestCheckInContext, CardLatestCheckInProvider };